import type { OfferPhase } from "@/lib/offer-calc";

/**
 * Aksentfarger per fase. Brukes som tynn fargestripe i venstre kant av
 * hver linjerad og som dot/badge i fase-overskrifter.
 *
 * Verdiene er fra Variant 4-mockupen (Tilbud — Eksport.html). Production
 * arver Sølvrev primary (`--sr-reveblaa`) for å holde flåten i stilen.
 */
export const PHASE_COLORS: Record<OfferPhase, string> = {
  pl: "#7B6F8A",
  preprod: "#5A7A9B",
  production: "#031EFF",
  postprod: "#5A8A6E",
  stills: "#B58A4A",
  reise: "#9B5E5A",
};

export const PHASE_LABEL: Record<OfferPhase, string> = {
  pl: "Prosjektledelse",
  preprod: "Preproduksjon",
  production: "Produksjon",
  postprod: "Postproduksjon",
  stills: "Stills",
  reise: "Reise",
};

/** Faste rekkefølge for visning. */
export const PHASE_ORDER: OfferPhase[] = [
  "pl",
  "preprod",
  "production",
  "postprod",
  "stills",
  "reise",
];
